import { render, staticRenderFns } from "./palm.vue?vue&type=template&id=6114a53c&scoped=true&"
import script from "./palm.vue?vue&type=script&lang=ts&"
export * from "./palm.vue?vue&type=script&lang=ts&"
import style0 from "./palm.vue?vue&type=style&index=0&id=6114a53c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6114a53c",
  null
  
)

export default component.exports